import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import './Header.css';
import Button from '../Button';

class Header extends Component {
  constructor() {
    super();
		this.handleDemoClick = this.handleDemoClick.bind(this);
  }

	handleDemoClick() {
		this.props.handlePrimaryClick();
	}

  render() {
    return (
			<div className="header">
				<h3 className="header__title">
					{this.props.title}
				</h3>
				<Button
					onClick={this.props.handleLogout}
					hollow={true}
					pullRight={true}
					text="LOGOUT" />
				{
					this.props.primaryText &&
					<Button
						onClick={this.handleDemoClick}
						pullRight={true}
						text={this.props.primaryText} />
				}
				<div className="clear"></div>
			</div>
    );
  }
}

Header.propTypes = {
  handleLogout: PropTypes.func.isRequired,
	handlePrimaryClick: PropTypes.func,
	title: PropTypes.string.isRequired
};

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header/index.js
 **/